// Cache des fiches event en localStorage (clés event_details_*, cf. EventDetailsPage et useEventData).
// Il contient des données client et n'expire qu'à la lecture : on le vide à la déconnexion, sinon il
// reste sur un poste partagé pour le prochain utilisateur.
const PREFIX = 'event_details_';

export const clearEventDetailsCache = () => {
  try {
    Object.keys(localStorage).filter((key) => key.startsWith(PREFIX)).forEach((key) => localStorage.removeItem(key));
  } catch (err) {
    // localStorage indisponible (navigation privée, stockage bloqué) : rien à purger.
  }
};

export default clearEventDetailsCache;
